import { useEffect, useState } from "react";
import AdminLayout, { PageHeader } from "../../components/admin/AdminLayout";
import api, { formatApiError, BACKEND } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { toast } from "sonner";
import { Eye, Trash, DownloadSimple } from "@phosphor-icons/react";

export default function Applications() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const { data } = await api.get("/admin/applications");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!confirm("Delete this application?")) return;
    try { await api.delete(`/admin/applications/${id}`); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <AdminLayout>
      <PageHeader title="Applications" subtitle="Candidates who have applied through the careers page." />
      <div className="p-8">
        <div className="bg-white border border-[#E2E8F0] rounded-lg overflow-hidden" data-testid="apps-table">
          <table className="w-full text-sm">
            <thead className="bg-[#F7F8F6] text-left text-[10px] tracking-[0.2em] uppercase text-[#4B5563]">
              <tr>
                <th className="px-6 py-3">Candidate</th>
                <th className="px-6 py-3">Email</th>
                <th className="px-6 py-3">Role</th>
                <th className="px-6 py-3">Received</th>
                <th className="px-6 py-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]">
              {items.length === 0 && <tr><td colSpan={5} className="px-6 py-10 text-center text-[#4B5563]">No applications yet.</td></tr>}
              {items.map((it) => (
                <tr key={it.id} data-testid={`app-row-${it.id}`}>
                  <td className="px-6 py-3 font-medium text-[#1F2937]">{it.name}</td>
                  <td className="px-6 py-3 text-[#4B5563]">{it.email}</td>
                  <td className="px-6 py-3 text-[#4B5563]">{it.job_title}</td>
                  <td className="px-6 py-3 text-[#4B5563] text-xs">{new Date(it.created_at).toLocaleString()}</td>
                  <td className="px-6 py-3 text-right">
                    <button onClick={() => setSelected(it)} data-testid={`view-${it.id}`} className="text-[#4B5563] hover:text-[#C2410C] mr-3"><Eye size={16} /></button>
                    {it.resume_url && (
                      <a href={`${BACKEND}${it.resume_url}`} target="_blank" rel="noreferrer" className="text-[#4B5563] hover:text-[#C2410C] mr-3 inline-block">
                        <DownloadSimple size={16} />
                      </a>
                    )}
                    <button onClick={() => remove(it.id)} data-testid={`delete-${it.id}`} className="text-[#4B5563] hover:text-[#EF4444]"><Trash size={16} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent data-testid="app-dialog">
          <DialogHeader><DialogTitle>{selected?.name}</DialogTitle></DialogHeader>
          {selected && (
            <div className="space-y-3 text-sm">
              <div className="grid grid-cols-3 gap-2">
                <div className="text-[#4B5563]">Email</div><div className="col-span-2">{selected.email}</div>
                {selected.phone && <><div className="text-[#4B5563]">Phone</div><div className="col-span-2">{selected.phone}</div></>}
                <div className="text-[#4B5563]">Role</div><div className="col-span-2">{selected.job_title}</div>
              </div>
              {selected.cover_letter && (
                <div className="border-t border-[#E2E8F0] pt-3">
                  <div className="text-xs text-[#4B5563] uppercase tracking-[0.18em] mb-2">Cover letter</div>
                  <p className="whitespace-pre-wrap text-[#1F2937]">{selected.cover_letter}</p>
                </div>
              )}
              {selected.resume_url && (
                <a href={`${BACKEND}${selected.resume_url}`} target="_blank" rel="noreferrer" className="text-[#C2410C] underline text-sm">
                  Download resume
                </a>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
}
